/**
 * Analytics events fired by the landing pages. The site has no analytics tool
 * yet, so `track` only logs to the console — wire a provider in below when one
 * is added, and every call site starts reporting.
 */
export type TrackEvent =
    | 'video_play'
    | 'video_progress_50'
    | 'video_complete'
    | 'cta_book_call_click'
    | 'cta_whatsapp_click';

export type TrackProps = Record<string, string | undefined>;

export function track(event: TrackEvent, props: TrackProps = {}): void {
    // Drop unset values so optional props (e.g. `company`) only appear when present.
    const payload: Record<string, string> = {};
    Object.entries(props).forEach(([key, value]) => {
        if (value) payload[key] = value;
    });

    // Plug an analytics tool in here, e.g.:
    //   window.gtag?.('event', event, payload);             // GA4
    //   window.fbq?.('trackCustom', event, payload);        // Meta Pixel
    //   window.posthog?.capture(event, payload);            // PostHog
    console.info('[track]', event, payload);
}
